// extracted by mini-css-extract-plugin
export default {"Shortcut_Keys":"ContentWithShortcut_Shortcut_Keys__ItxhW","MacOs":"ContentWithShortcut_MacOs__jfCAM"};